import Swal from "sweetalert2";

import api from "./api";
import { CreateLotacaoDto, GetLotacaoDto, UpdateLotacaoDto } from "../shared/dtos/Lotacao.dto";

class LotacaoService {
  async getAllLotacoes(): Promise<GetLotacaoDto[]> {
    return api
      .get("/lotacao/getAll")
      .then((response) => {
        return Promise.resolve(response.data as GetLotacaoDto[]);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar lotações`);
        return Promise.reject(error);
      });
  }

  async getLotacaoById(id: number): Promise<GetLotacaoDto> {
    return api
      .get(`/lotacao/findOne/${id}`)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao buscar lotação com ID ${id}`);
        return Promise.reject(error);
      });
  }

  async createLotacao(lotacaoData: CreateLotacaoDto): Promise<GetLotacaoDto> {
    return api
      .post("/lotacao/create", lotacaoData)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, "Erro ao criar lotação");
        return Promise.reject(error);
      });
  }

  async updateLotacao(id: number, lotacaoData: UpdateLotacaoDto): Promise<GetLotacaoDto> {
    return api
      .patch(`/lotacao/update/${id}`, lotacaoData)
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        this.handleError(error, `Erro ao atualizar lotação com ID ${id}`);
        return Promise.reject(error);
      });
  }

  async deleteLotacao(id: number): Promise<void> {
    return api
      .delete(`/lotacao/delete/${id}`)
      .then(() => {
        return Promise.resolve();
      })
      .catch((error) => {
        this.handleError(error, `Erro ao deletar lotação com ID ${id}`);
        return Promise.reject(error);
      });
  }

  private handleError(error: any, message: string): void {
    if (error.response) {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.response.data}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    } else {
      Swal.fire({
        title: "Erro",
        text: `${message}: ${error.message || "Erro desconhecido"}`,
        icon: "error",
        confirmButtonText: "Fechar",
        allowOutsideClick: false,
      });
    }
  }
}

const lotacaoService = new LotacaoService();
export default lotacaoService;
